import { StatusBar } from '@capacitor/status-bar';
import { isNative, isAndroid } from './platformUtils';

export const configureStatusBar = async () => {
  if (!isNative()) return;

  try {
    await StatusBar.setStyle({ style: 'DARK' });
    if (isAndroid()) {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#0a0a0c' });
    }
  } catch (error) {
    console.error('Status bar configuration error:', error);
  }
};